<template>
  <div>
    <div
      v-for="(layer, layerIndex) in value"
      :key="layerIndex"
    >
      <component
        v-bind="fields.props"
        :is="fields.component"
        :value="layer"
        :deletable="true"
        @input="$_onStateInput($event,layerIndex)"
        @delete="$_onStateDelete(layerIndex)"
      ></component>
      <div
        class="ml-10"
        v-if="layer.layers"
      >
        <WsUpdateMultiLayerLayers
          :value="layer.layers"
          :fields="fields"
          @input="$_onInfiniteLayersInput($event, layerIndex)"
          @delete="$_onInfiniteLayersDelete($event, layerIndex)"
        ></WsUpdateMultiLayerLayers>
      </div>
      <div>
      <template
        v-for="(btn, btnIndex) in fields.btn"
      >
        <WsBtn
          v-if="btn.$_visibility ? btn.$_visibility(layer) : true"
          :key="btnIndex"
          minWidth="100px"
          :color="btn.color"
          :outlined="btn.outline"
          class="mr-2 mb-2"
          @click="$_onAddFirstLayerAllValue(layer, layerIndex, btn)"
        >
          <v-icon
            left
            v-if="btn.icon"
          >{{btn.icon}}</v-icon>{{btn.text}}
        </WsBtn>
      </template>
      </div>
    </div>
    <template
      v-if="!value"
    >
      <WsBtn
        minWidth="100px"
        :color="fields.btn[0].color"
        :outlined="fields.btn[0].outline"
        class="mr-2"
        @click="$_onCreateLayer(fields.btn[0])"
      >
        <v-icon
          left
          v-if="fields.btn[0].icon"
        >{{fields.btn[0].icon}}</v-icon>{{fields.btn[0].text}}
      </WsBtn>
    </template>
  </div>
</template>

<script>
export default {
  methods: {
    $_onStateInput($event, layerIndex) {
      const _value = [...this.value];
      _value[layerIndex] = { ...$event };
      this.$emit("input", {fullValue: _value, updateValue: $event});
    },
    $_onInfiniteLayersInput($event, layerIndex) {
      const _value = [...this.value];
      _value[layerIndex].layers = [...$event.fullValue];
      if (
        $event.updateValue[`sibling_${this.valueKey}`] !== undefined
        && $event.updateValue[`parent_${this.valueKey}`] === undefined
      ) {
        $event.updateValue[`parent_${this.valueKey}`] = _value[layerIndex][`${this.valueKey}`]
      }
      this.$emit("input", {fullValue: _value, updateValue: $event.updateValue});
    },
    $_onAddFirstLayerAllValue(layer, layerIndex, btn) {
      const newValue = {}
      for (let key in layer) {
        if (key === `parent_${this.valueKey}` || key === `sibling_${this.valueKey}`) {
          continue
        }
        newValue[`${key}`] = null
      }
      const _value = [...this.value];
      if (btn.isCreateSubLayer) {
        newValue[`parent_${this.valueKey}`] = _value[layerIndex][`${this.valueKey}`]
        _value[layerIndex].layers = [newValue]
        this.$emit("input", {fullValue: _value, updateValue: newValue});
      } else {
        newValue[`sibling_${this.valueKey}`] = _value[layerIndex][`${this.valueKey}`]
        const index = layerIndex + 1
        _value.splice(index, 0, newValue);
        this.$emit("input", {fullValue: _value, updateValue: newValue});
      }
    },
    $_onStateDelete(layerIndex) {
      const _value = [...this.value];
      const deleteValue = _value[layerIndex]
      _value.splice(layerIndex, 1)
      let emitEvent = ""
      if (
        deleteValue[`${this.valueKey}`] !== undefined
        && deleteValue[`${this.valueKey}`] !== null
      ) {
        emitEvent = "delete"
      } else {
        emitEvent = "input"
      }
        this.$emit(emitEvent, {fullValue: _value, deleteValue: deleteValue})
    },
    $_onInfiniteLayersDelete($event, layerIndex) {
      const _value = [...this.value]
      _value[layerIndex].layers = [...$event.fullValue];
      this.$emit("delete", {fullValue: _value, deleteValue: $event.deleteValue});
    },
    $_getKey(valueItem) {
      if (!valueItem.state.id && !valueItem.state.fakeId) {
        let date = new Date();
        const _fakeKey = `${date.getMonth()}${date.getDate()}${date.getMinutes()}${Math.random()
          .toString(36)
          .substring(10)}`;
        valueItem.state.fakeId = _fakeKey;
      }
      return valueItem.state.id || valueItem.state.fakeId;
    },
    $_onCreateLayer() {
      const updateValue = {[`${this.valueKey}`]: null, [`${this.textKey}`]: null}
      this.$emit("input", {fullValue: [updateValue], updateValue});
    }
  },
  props: {
    value: {},
    textKey: {
      type: String,
      default: 'name',
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    fields: {
      type: Object,
    }
  },
};
</script>